
import { IAvailableMongoViewColumn, MongoViewColumn } from "@/utils/mongo-view/mongo-view-column";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data(){
		return {
			col: new MongoViewColumn()
		};
	},
	props: {
		value: {
			type: Object as ()=>MongoViewColumn,
			required: true
		},
		availableColumns: {
			type: Array as ()=>IAvailableMongoViewColumn[],
			required: true
		},
		isNew: Boolean
	},
	computed: {
		title():TranslateResult{
			if (this.isNew) {
				return this.$ct("create-new-column");
			}
			return this.$ct("edit-column");
		},
		availableColumnsItems():ISelectItem<string>[]{
			return this.availableColumns.map(c=>{
				return {
					text: c.name,
					value: c.viewColumnName
				};
			});
		},
		selectedColumn():IAvailableMongoViewColumn{
			return this.availableColumns.find(v=>v.viewColumnName == this.col.Property) || this.availableColumns[0];
		},
		minColWidth():number{
			return 50;
		},
		width():string{
			let val = this.col.Width ? parseInt(this.col.Width) : 0;
			if (Number.isNaN(val) || val < this.minColWidth){
				return `${this.selectedColumn.width}`;
			}
			return `${val}`;
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.col = new MongoViewColumn(this.value.getJSON());
			}
		}
	},
	methods: {
		setProperty(value:string){
			let prop = this.availableColumns.find(v=>v.viewColumnName == value) || this.availableColumns[0];
			this.col = MongoViewColumn.fromAvailableColumn(prop);
		},
		setWidth(val:number){
			this.col.Width = `${val}`;
		},
		close(){
			this.$emit("close");
		},
		confirm(){
			this.col.key = this.value.key;
			this.$emit("input", this.col);
			this.close();
		}
	},
	i18nEx: {
		componentPrefix: "components.mongo-view-editor"
	}
});
